import SubsectionTitle from './SubsectionTitle';
import { useState, useEffect } from 'react';

export default function Summary({ settings, cartAttributes }) {
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [totalCartQuantity, setTotalCartQuantity] = useState(0);

	useEffect(() => {
		const allProducts = Array.from(document.querySelectorAll('.order-summary__body tr'));
		const filteredProducts = allProducts.filter((product) => !product.closest('.cart-drawer'));
		const totalCartQuantity = filteredProducts.reduce((acc, product) => {
			const quantityInput = product.querySelector('.quantity-input');

			return acc + (quantityInput ? parseInt(quantityInput.value) : 0);
		}, 0);

		setTotalCartQuantity(totalCartQuantity);
		setFilteredProducts(filteredProducts);
	}, [cartAttributes]);

	const getStepTitle = (index, title) => {
		switch (index) {
			case 0:
				return (
					<>
						{title}
						{totalCartQuantity < 100 && <span className="circle-total-quantity">{totalCartQuantity}</span>}
					</>
				);
			case 1:
				return cartAttributes.deliveryMethod === 'delivery'
					? settings.buttonDeliveryLabel
					: settings.buttonPickupLabel;
			default:
				return title;
		}
	};

	const getStepContent = (index) => {
		switch (index) {
			case 0:
				return (
					<div className="summary__products">
						{filteredProducts.length > 0 &&
							filteredProducts.map((product, productIndex) => {
								const titleElement = product.querySelector('.line-item__title');
								const quantityElement = product.querySelector('.quantity-input');

								if (!titleElement) return null;

								return (
									<div key={productIndex} className="summary__product">
										<p className="text-base">
											{titleElement.textContent} x {quantityElement.value}
										</p>
									</div>
								);
							})}
						<div className="divider"></div>
					</div>
				);
			case 1:
				return (
					<div className="summary__delivery">
						{cartAttributes.desiredDate && (
							<p className="text-base">
								<span className="text-subdued">{settings.selectedDateTime}</span>
								{cartAttributes.desiredDate}{' '}
								{cartAttributes.desiredTime ? (
									cartAttributes.desiredTime
								) : (
									<span className="text-error">{settings.timeNotSelected}</span>
								)}
							</p>
						)}

						{cartAttributes.deliveryMethod === 'pickup' && (
							<p className="text-base">
								<span className="text-subdued">{settings.pickupLocationText}</span>
								{cartAttributes.pickupLocation ? (
									cartAttributes.pickupLocation
								) : (
									<span className="text-error">{settings.locationNotSelected}</span>
								)}
							</p>
						)}

						<div className="divider"></div>
					</div>
				);
			case 2:
				return null;
			case 3:
				return (
					<div className="summary__invoice">
						{cartAttributes.invoiceType === 'pj' && (
							<p className="text-base">
								<span className="text-subdued">{settings.cuiLabel}</span>
								{cartAttributes.cui ? (
									cartAttributes.cui
								) : (
									<span className="text-error">{settings.cuiIncomplete}</span>
								)}
							</p>
						)}
						<p className="text-base">
							<span className="text-subdued">{settings.invoiceTypeLabel}</span>
							{cartAttributes.invoiceType === 'pf' ? settings.individualPerson : settings.legalEntity}
						</p>
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<div className="summary">
			<SubsectionTitle settings={settings} stepNumber={5} cartAttributes={cartAttributes} />

			<div className="summary__content">
				<div
					className={`summary__steps ${
						cartAttributes.deliveryMethod == 'digitalProductsOnly' && 'summary__steps--full-width'
					}`}
				>
					{settings.stepsTitles.split(',').map((title, index) => {
						if (index === 2) return null;

						if (cartAttributes.deliveryMethod == 'digitalProductsOnly' && index === 1) {
							return null;
						}

						return (
							<div key={index} className="summary__step">
								<a href={`#step-${index + 1}`}>
									<p className="h5">{getStepTitle(index, title)}</p>
								</a>
								{getStepContent(index)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
